import { render, staticRenderFns } from "./VersionAlert.vue?vue&type=template&id=0a84cf06&scoped=true&"
import script from "./VersionAlert.vue?vue&type=script&lang=js&"
export * from "./VersionAlert.vue?vue&type=script&lang=js&"
import style0 from "./VersionAlert.vue?vue&type=style&index=0&id=0a84cf06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a84cf06",
  null
  
)

export default component.exports